import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MultilingualDateAdapter } from '../../../adapters/multilingual-date.adapter';
import { MultilingualDatePipe } from '../../../pipes/multilingual-date.pipe';

@Component({
  selector: 'app-si-date-picker',
  imports: [FormsModule, CommonModule, MatInputModule, MatDatepickerModule, MatFormFieldModule, ReactiveFormsModule, MultilingualDatePipe],
  templateUrl: './si-date-picker.component.html',
  styleUrl: './si-date-picker.component.scss',
  providers: [
    { provide: DateAdapter, useClass: MultilingualDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SiDatePickerComponent),
      multi: true
    }
  ]
})
export class SiDatePickerComponent implements ControlValueAccessor {

  @Input() isReadMode: boolean = true;
  private externalDisabled = false;
  private formControlDisabled = false;

  @Input() set isDisabled(value: boolean) {
    this.externalDisabled = value;
  }

  get isDisabled(): boolean {
    return this.externalDisabled || this.formControlDisabled;
  }

  @Input() value: string | null = '';
  @Input() minDate: string | null = null;
  @Output() inputValueChange = new EventEmitter<string>();

  private onChange = (value: any) => {};
  private onTouched = () => {};

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDisabled = isDisabled;
  }

  // Handle date changes
  onDateChange(event: any): void {
    if (this.isDisabled || this.isReadMode) {
      return;
    }

    const newValue = event?.value instanceof Date 
      ? this.toLocalDateString(event.value) 
      : event?.target?.value || null;
    
    this.value = newValue;
    this.onChange(newValue);
    this.inputValueChange.emit(newValue);
  }

  onBlur(): void {
    this.onTouched();
  }

  private toLocalDateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
